"use strict";

exports.__esModule = true;
exports["default"] = void 0;
// const DEFAULT_PROPS = {
//   resourceType: "SmallSummary_1_0_0",
//   summaryText: "Your ",
//   changeText: "Change",
//   editText: "Edit",
//   includedText: "Included",
//   copyText:
//     "Modified with a sporty edge and a great view, with a panoramic glass roof for beautiful sights day or night",
//   summaryTitle: "Your Summary",
//   configurationTitle: "Your configuration",
//   customisationTitle: "Your customisations",
//   hideLink: "Hide Summary",
//   nextButton: "Next:",
//   summaryImage:
//     "https://cms.dev.mmcmason.co/content/dam/mitsubishi-motors-dev-stubs/configurator-summary/summary-image.png",
//   toggleImage:
//     "https://cms.dev.mmcmason.co/content/dam/mitsubishi-motors-dev-stubs/configurator-small-summary/expandable-arrow.svg",
//   viewSummary: "View Summary",
//   hideSummary: "Hide Summary",
//   vehicle: {
//     id: "ASX_1",
//     code: "ASX",
//     price: {
//       label: "",
//       value: 21035.0,
//       displayValue: ""
//     },
//     name: "ASX",
//     selected: true
//   },
//   model: {
//     id: "Intense",
//     code: "INT",
//     price: {
//       label: "",
//       value: 21035.0
//     },
//     name: "Intense"
//   },
//   color: {
//     id: "Frost_White",
//     type: "exterior-color",
//     code: "NAH",
//     label: "Frost White",
//     price: {
//       label: "",
//       value: 0.0,
//       displayValue: ""
//     },
//     titleAndText: {
//       title: "",
//       text:
//         "Inspired By The Frost That Sits On Top Of Mount Fuji, Without Fear. So Don't Be Afraid To Get It Muddy."
//     },
//     selected: true
//   },
//   fabric: {
//     id: "Nappa_Leather",
//     type: "fabric",
//     code: "NAP",
//     label: "Nappa Leather",
//     price: {
//       label: "",
//       value: 500.0,
//       displayValue: ""
//     },
//     titleAndText: {
//       title: "",
//       text: "Premium leather to express your individual style."
//     },
//     selected: true
//   },
//   packages: [
//     {
//       id: "Protection_Pack",
//       type: "package",
//       code: "POC",
//       label: "Protection Pack",
//       price: {
//         label: "",
//         value: 250.0,
//         displayValue: ""
//       },
//       titleAndText: {
//         title: "",
//         text:
//           "This pack protects your new ASX from anything the elements can throw at it."
//       },
//       selected: true
//     }
//   ],
//   accessories: [
//     {
//       id: "13_Pin_Towbar",
//       type: "accessory",
//       code: "ACC",
//       label: "13 Pin Towbar",
//       price: {
//         label: "",
//         value: 150.0,
//         displayValue: ""
//       },
//       titleAndText: {
//         title: "",
//         text:
//           "The Towbar has been extensively tested and is engineered specifically for your ASX."
//       },
//       selected: true
//     }
//   ],
//   totalPrice: {
//     label: "",
//     value: 21935.0,
//     displayValue: ""
//   },
//   driveType: {
//     id: "2WD",
//     type: "drive-type",
//     code: "2WD",
//     label: "2WD",
//     image: {
//       altText: "",
//       image: "./2-wheels.png"
//     },
//     selected: true
//   },
//   fuelType: {
//     id: "Petrol_1.6",
//     type: "fuel-type",
//     code: "P16",
//     label: "1.6 Petrol",
//     selected: true
//   },
//   transmissionType: {
//     id: "Manual",
//     type: "transmission-type",
//     code: "MNL",
//     label: "Manual",
//     image: {
//       altText: "",
//       image: "./shifter-knob.png"
//     },
//     selected: true
//   }
// };
var DEFAULT_PROPS = {
  resourceType: 'SmallSummary_1_0_0',
  configuratorCode: '4k7UQMHjwawH',
  configurationTitle: 'Your Configuration',
  customisationTitle: 'Your Customizations',
  includedText: 'Included',
  editText: 'Edit',
  nextButton: 'Next :',
  hideLink: 'View Summary',
  summaryText: 'Your',
  changeText: 'Change',
  copyText: 'Copy',
  viewSummary: 'Your Summary',
  hideSummary: 'View Summary',
  selectedVehicleImage: {
    image: '/content/dam/mitsubishi-motors-dev-stubs/table-mixed/Front-Specs.png',
    altText: 'alt text'
  },
  vehicle: {
    id: '6',
    code: 'OU',
    price: {
      value: 10000000,
      displayValue: '€10,000,000.00',
      label: 'From en-gb'
    },
    vehicleImage: {
      image: '/content/dam/mitsubishi-motors-dev-stubs/table-mixed/Front-Specs.png',
      altText: 'alt text'
    },
    vehicleBackgroundImage: {
      image: '/content/dam/mitsubishi-motors-dev-stubs/car-featurette/car-featurette-hero.jpg',
      altText: null
    },
    name: 'Outlander GB',
    description: null,
    selected: true,
    tag: null
  },
  model: {
    id: '2',
    code: 'OU19MKGBL201',
    price: {
      label: 'From en-gb',
      value: 10000525.98,
      displayValue: '€10,000,525.98',
      baseValue: 10000000,
      fees: [{
        id: 7,
        label: 'Maintenance',
        value: 250
      }, {
        id: 8,
        label: 'Tax',
        value: 199.99
      }, {
        id: 9,
        label: 'Maintenance 2',
        value: 30
      }, {
        id: 10,
        label: 'Tax 2',
        value: 45.99
      }]
    },
    name: 'Outlander Diesel',
    description: null,
    descriptionList: null,
    selected: true,
    defaultMonthlyLeasePayment: 500,
    monthlyPaymentTerms: 'payment term text',
    cabType: 'Single Cab',
    engineSize: '2.0L',
    engineCode: '4J12',
    engineType: '16-valve inline 4-cylinder SOHC MIVEC ECI- Multi',
    fuelType: 'diesel',
    transmissionType: 'Manual',
    transmissionCode: '5MT',
    transmissionDescription: '5-Speed Manual Transmission',
    drivetrain: '4WD',
    seats: 7,
    doors: 4
  },
  color: {
    id: '3',
    type: 'exterior',
    code: 'co3',
    label: 'color3',
    image: {
      altText: null,
      image: 'https://cms.dev.mmcmason.co/content/dam/mitsubishi-motors-gb/images/cars/outlander_gb/2019/color-picker/exterior/co3_0_0.png'
    },
    imageSelected: {
      altText: null,
      image: null
    },
    price: {
      label: '+',
      value: 0,
      displayValue: '€0'
    },
    titleAndText: {
      title: null,
      text: 'description3_after'
    },
    selected: true,
    link: null
  },
  fabric: {
    id: '1',
    type: 'interior',
    code: 'co1',
    label: 'color1',
    image: {
      altText: null,
      image: null
    },
    imageSelected: {
      altText: null,
      image: null
    },
    price: {
      label: '+',
      value: 12000,
      displayValue: '€12,000.00'
    },
    titleAndText: {
      title: null,
      text: 'description1'
    },
    selected: true,
    link: null
  },
  totalPrice: {
    label: 'From en-gb',
    value: 10012525.98,
    displayValue: '€10,012,525.98',
    baseValue: 10012000,
    fees: null
  },
  driveType: {
    id: '4WD',
    type: 'drive_train',
    code: '4WD',
    label: '4WD',
    image: {
      altText: '',
      image: 'https://cms.dev.mmcmason.co/content/dam/mitsubishi-motors/images/icons/drive_train_4WD.svg'
    }
  },
  fuelType: {
    id: 'diesel',
    type: 'fuel_type',
    code: 'diesel',
    label: 'Diesel',
    image: {
      altText: '',
      image: 'https://cms.dev.mmcmason.co/content/dam/mitsubishi-motors/images/icons/fuel_type_diesel.svg'
    },
    imageSelected: null,
    price: null,
    titleAndText: {
      text: null
    },
    includedOptions: [],
    selected: true
  },
  transmissionType: {
    id: 'Manual',
    type: 'transmission_type',
    code: 'Manual',
    label: 'Manual',
    image: {
      altText: '',
      image: 'https://cms.dev.mmcmason.co/content/dam/mitsubishi-motors/images/icons/transmission_type_Manual.svg'
    }
  }
};
var _default = DEFAULT_PROPS;
exports["default"] = _default;